import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import { IPayment } from "@/apps/merchant3/models/IPayment";

const actions = {
  setPaymentInfo: ({ commit }: ICommit, payload: IPayment): void => {
    commit("SET_PAYMENT_INFO", payload);
  },
  removePaymentInfo: ({ commit }: ICommit): void => {
    commit("REMOVE_PAYMENT_INFO");
  },
  setPaymentId: ({ commit }: ICommit, payload: string): void => {
    commit("SET_PAYMENT_ID", payload);
  },
};

export default actions;
